import { Constants } from '@pwc/pwc-deals-web-common';
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getProjectTerritory } from '../../../project/projectSlice';
import { RedirectV1V2 } from '../RedirectV1V2';
import StructuredAnalysisViewingToggledDataBanner from '../StructuredAnalysisViewingToggledDataBanner/StructuredAnalysisViewingToggledDataBanner';
import './StructuredAnalysisContainer.scss';
// TODO localize
const NETHERLANDS_TEXT = `You may choose to use Junction to manipulate output prepared by PwC for its client (“your results”). 
Your results are for your convenience and general information purposes only.  PwC makes no representation with respect to your results, 
including, without limitation, fitness for any particular purpose. PwC is not liable for your or others’ use of, or reliance on, your results.`;

const TEXT =
  'Any adjustments to the output prepared by PwC are at your discretion and for your convenience and general information purposes only. PwC accepts no liability to you or anyone else in connection with the results.';

export const withStructuredContainer = (WrappedStructuredContainer) => () =>
  (
    <RedirectV1V2>
      <StructuredAnalysisContainer>
        <WrappedStructuredContainer />
      </StructuredAnalysisContainer>
    </RedirectV1V2>
  );

const ToggledDisclaimerModal = ({ showModal, closeModal }) => {
  const toggledDisclaimerTitle = 'Visual Interactive Disclaimer';
  const territory = useSelector(getProjectTerritory);
  const toggledDisclaimerMessage =
    territory === Constants.TERRITORY_CODES.NETHERLANDS
      ? NETHERLANDS_TEXT
      : TEXT;

  return (
    <Modal
      show={showModal}
      onHide={() => closeModal(false)}
      className="disclaimer-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="disclaimer-modal-title">
          <h4>{toggledDisclaimerTitle}</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="scrollable disclaimer-modal-body">
        <div
          data-testid="project-disclaimer-content"
          className="project-disclaimer-content"
        >
          {toggledDisclaimerMessage}
        </div>
      </Modal.Body>
    </Modal>
  );
};

const StructuredAnalysisContainer = ({ children }) => {
  const [showModal, openModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    return () => {
      document.documentElement.style.setProperty(
        '--app-banner-height-offset',
        `${0}px`
      );
    };
  }, [location]);

  return (
    <>
      <StructuredAnalysisViewingToggledDataBanner
        showDisclaimerModal={openModal}
      />
      <ToggledDisclaimerModal showModal={showModal} closeModal={openModal} />
      {children}
    </>
  );
};

export default StructuredAnalysisContainer;
